import { PartialSearchActionTypes } from '../../../enums/ActionEnums';
export const partialSearchActions = {
    createInitializeAction: () => ({
        type: PartialSearchActionTypes.INIT,
    }),
};
